function requestAPI(data, token) {
  return fetch(`${process.env.REACT_APP_ADMIN_URL}setting-referral`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    },
    body: JSON.stringify(data)
  }).then((res) => res.json())
}

export default function actionUpdateSettingReferral(data) {
  return async (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_SETTING_REFERRAL_BEGIN'
    })

    try {
      const token = await getState().auth.authenticate.token
      const result = await requestAPI(data, token)
      if(!result.status) {
        handleErrors(dispatch, result)
        return
      }

      dispatch({
        type: 'UPDATE_SETTING_REFERRAL_SUCCESS',
        success: result
      })
    } catch (err) {
      handleErrors(dispatch, err)
    }
  }
}

function handleErrors(dispatch, error) {
  dispatch({        
    type: 'UPDATE_SETTING_REFERRAL_FAILURE',        
    error: error    
  })
}
